import { useEffect, useState } from 'react';
import { generateSitemap } from '../utils/sitemap';

export function SitemapPage() {
  const [sitemap, setSitemap] = useState('');

  useEffect(() => {
    generateSitemap().then(setSitemap);
  }, []);

  return (
    <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      {sitemap}
    </pre>
  );
}

